const kB = 1024;
const MB = kB * kB;
const GB = kB * MB;
export const MAX_VIDEO_FILE_SIZE = 1 * GB;
export const ACCEPTED_VIDEO_TYPES = ['video/mp4', 'video/x-m4v', 'video/quicktime'];
export const videoTypeRegex = /\.(mp4|mov)$/i;
